<div class="v4-layout-info" [formGroup]="form" [class.editing]="isEditing">
  <div class="v4-layout-info-title flex flex-row items-center justify-between">
    <div>
      <span>{{ "word.fee" | translate }} </span>
      <span *ngIf="!isEditing || orderDetail?.thirdparty_type !== 5; else editingFeeCurrencyField"
        >({{ currencyType }}{{ currencySymbol }})</span
      >
      <ng-template #editingFeeCurrencyField>
        <nz-select
          formControlName="currency_type"
          [nzOptions]="optionsOfCurrency"
          [nzDropdownMatchSelectWidth]="false"></nz-select>
      </ng-template>
    </div>

    <div>
      @if (!isEditing) {
        <!-- 记账 -->
        <a nz-button nzType="link" nzSize="small" (click)="onKeepAccount()">
          {{ "word.add_note" | translate }}
        </a>
        <!-- 编辑 -->
        <a class="ml-2" nz-button nzType="link" nzSize="small" (click)="onEdit.emit()">
          {{ "word.modify" | translate }}
        </a>
      } @else {
        <a nz-button nzType="link" nzSize="small" (click)="onCancelEdit.emit()">
          {{ "word.cancel" | translate }}
        </a>
        <a class="ml-2" nz-button nzType="link" nzSize="small" (click)="onModifyFee()">
          {{ "word.save" | translate }}
        </a>
      }
    </div>
  </div>

  <div class="v4-layout-fields">
    <!-- 房费： -->
    <div class="v4-layout-field">
      <div class="v4-layout-field-label">
        <span>{{ "order.detail_house_fee" | translate }}</span>
      </div>
      <div class="v4-layout-field-control">
        <div class="v4-layout-field-row">
          <!-- 币种 -->
          <!-- <span> {{ currencySymbol }} </span> -->

          @if (!isEditing) {
            <span>{{ rate }}</span>
          } @else {
            <span> {{ currencySymbol }} </span>
            <nz-input-number
              class="mx-2 flex-1 min-w-[60px]"
              formControlName="house_fee"
              [nzMin]="0"
              [nzMax]="9999999999"
              [nzStep]="1"
              [nzPrecision]="2"
              nzPlaceHolder="{{ 'placeholder.fee_required' | translate }}"></nz-input-number>
          }

          <!-- 明细 -->
          <button
            *ngIf="orderDetail?.price_list?.length"
            nz-button
            nzSize="small"
            class="ml-2 no-min-width"
            nz-popover
            [nzPopoverTitle]="'order_detail.pop.fee_detail.title' | translate"
            [nzPopoverContent]="feeDetailContent">
            {{ "order_detail.pop.btn.fee_detail.title" | translate }}
          </button>
          <ng-template #feeDetailContent>
            <div class="flex flex-row text-c-d2">
              <div class="mr-5" *ngFor="let price of orderDetail?.price_list">
                {{ price.title }}：{{ price.currency | currencyToSymbol }}
                {{ price.amount }}
              </div>
            </div>
          </ng-template>
        </div>
      </div>
    </div>

    <!-- 佣金/总佣金 -->
    @if (commission) {
      <div class="v4-layout-field">
        <div class="v4-layout-field-label">
          <span>{{ (!isMultiHouseReservation ? "order.commission" : "order.order_commission") | translate }}</span>
        </div>
        <div class="v4-layout-field-control">
          <div class="v4-layout-field-row">
            @if (!isEditing || orderDetail?.thirdparty_type !== 5) {
              {{ commission }}
            } @else {
              <span>{{ currencySymbol }}</span>
              <nz-input-number
                class="mx-2 flex-1 min-w-[60px]"
                formControlName="commission"
                [nzMin]="0"
                [nzMax]="999999999"
                [nzStep]="1"
                [nzPrecision]="2"
                nzPlaceHolder="{{ 'placeholder.fee_required' | translate }}"></nz-input-number>
            }

            <!-- <span *ngIf="!isEditing || orderDetail?.thirdparty_type !== 5; else editingCommissionField">{{
              orderDetail?.amount_items?.commission?.amount
            }}</span>
            <ng-template #editingCommissionField>
              <nz-input-number
                class="mx-2 flex-1 min-w-[60px]"
                formControlName="commission"
                [nzMin]="0"
                [nzMax]="999999999"
                [nzStep]="1"
                [nzPrecision]="2"
                nzPlaceHolder="{{ 'placeholder.fee_required' | translate }}"></nz-input-number>
            </ng-template>

            <span>
              &nbsp;({{ (!isMultiHouseReservation ? "order.net_fee" : "order.order_net_fee") | translate }}
              &nbsp;
              {{ currencySymbol
              }}{{
                !isMultiHouseReservation
                  ? orderDetail?.amount_items?.net_house_fee?.amount
                  : orderDetail?.amount_items?.order_net_house_fee?.amount
              }})
            </span> -->
          </div>
        </div>
      </div>
    }

    <!-- 其他收入 -->
    @if (income) {
      <div class="v4-layout-field">
        <div class="v4-layout-field-label">
          <span>{{ "order.other_income" | translate }}</span>
        </div>
        <div class="v4-layout-field-control">
          <div class="v4-layout-field-row">
            <span>{{ currencySymbol }}{{ income }}</span>
          </div>
        </div>
      </div>
    }

    <!-- 支出 -->
    @if (outcome) {
      <div class="v4-layout-field">
        <div class="v4-layout-field-label">
          <span>{{ "order.outcome" | translate }}</span>
        </div>
        <div class="v4-layout-field-control">
          <div class="v4-layout-field-row">
            <span>{{ currencySymbol }}{{ outcome }}</span>
          </div>
        </div>
      </div>
    }
  </div>
</div>
